import { c as _c } from "react/compiler-runtime";
import { SVGProps } from 'react';
import SpinnerGradientDarkIcon from './spinner-gradient-dark.svg';
import SpinnerGradientLightIcon from './spinner-gradient-light.svg';
export function SpinnerGradientIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      theme: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const theme = t1 === undefined ? "light" : t1;
  if (theme === "light") {
    let t2;
    if ($[3] !== props) {
      t2 = <SpinnerGradientLightIcon {...props} />;
      $[3] = props;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== props) {
    t2 = <SpinnerGradientDarkIcon {...props} data-sentry-element="SpinnerGradientDarkIcon" data-sentry-component="SpinnerGradientIcon" data-sentry-source-file="spinner-gradient.tsx" />;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}